import Vue from "vue";

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');

window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.mixin({
    methods: {
        __(key, replace) {
            let translation;

            translation = window._labels[key]
                ? window._labels[key]
                : key

            _.forEach(replace, (value, key) => {
                translation = translation.replace(':' + key, value)
            })

            return translation
        }
    }
})

Vue.prototype._locale = window._locale;

import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

import carousel from 'vue-owl-carousel'
Vue.component('carousel', carousel);

const ImageZoom = require('vue-image-zoomer').default;
Vue.component('image-zoom', ImageZoom);

import Dayjs from 'vue-dayjs';

import { autoAnimatePlugin } from '@formkit/auto-animate/vue'

import Observer from 'vue-intersection-observer'
Vue.component('observer', Observer);

Vue.use(autoAnimatePlugin);

require('dayjs/locale/nl')
require('dayjs/locale/de')
require('dayjs/locale/fr')
require('dayjs/locale/en')

Vue.use(Dayjs);

const eventHub = new Vue() // Single event hub
Vue.mixin({
    data: function () {
        return {
            eventHub: eventHub
        }
    }
});

import { VueRecaptcha } from 'vue-recaptcha';
import vSelect from "vue-select";
Vue.component('recaptcha', VueRecaptcha);

Vue.component('v-select', vSelect)

import vue2Dropzone from 'vue2-dropzone'
Vue.component('vue-dropzone', vue2Dropzone)

jQuery(() => {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
